import React from "react";
import axios from "axios";
import styles from "../../static/css/pages.module.css";
import Dropdown from "../../components/form/dropdown/dropdown";
import Icon from "../../components/icons/icons";
import ieSvg from "../../components/icons/ieSvg";

class SelectRequestReference extends React.Component {
  constructor() {
    super();
    this.state = {
      result: {
        status: '',
        errorMessage: ''
      },
      link: false
    }
  }

  componentDidUpdate() {
    ieSvg();
  }

  handleSelect = (e) => {
    let fullLink = process.env.REACT_APP_GATE + this.props.link + e.value;
    let parent = this;
    this.setState({
      link: 'wait'
    });
    axios.get(fullLink, {data: {}})
        .then(response => {
          parent.setState(response.data)
          if (!response.data.data) return false;
          let fullLink = process.env.REACT_APP_GATE + 'storage/pdf/' + response.data.data.path;
          parent.setState({link: fullLink});
        })
        .catch(error => {
          window.location = process.env.PUBLIC_URL + "/error";
        });
  };

  render() {
    if (this.props.visibility) {
      let dropDownList = [],
          currentYear = (new Date()).getFullYear();
      for (let i = 2019; i <= currentYear; i++) {
        dropDownList.push({value: i, label: i});
      }
      return (
          <React.Fragment>
            {this.props.visibility === "true" ?
                <React.Fragment>
                  <div className={styles.form_title}>
                    {this.props.title}
                  </div>
                  <div className={styles.article}>
                    {this.props.label}
                  </div>
                  <div className={`l-grid ${styles.article}`}>
                    <div className="l-grid__item_4">
                      <Dropdown label="Год"
                                placeholder="Выберите"
                                required
                                name="year"
                                onChange={this.handleSelect}
                                items={dropDownList}/>
                    </div>
                    <div className="l-grid__item_8 l-grid_align-middle file-link-container">
                      {this.state.link ?
                          <ShowFile linkRegistration={this.state.linkRegistration}
                                    result={this.state.result}
                                    link={this.state.link}
                                    title={this.props.title}/>
                          :
                          null
                      }
                    </div>
                  </div>
                </React.Fragment>
                :
                null
            }
          </React.Fragment>
      )
    }
  }
}

class ShowFile extends React.Component {

  render() {
    if (this.props.result.status === 'TIMEOUT') {
      return (
          <div className={styles.status_error}>
            <div>Сервис временно недоступен, повторите операцию позже</div>
          </div>
      )
    }
    if (this.props.result.status === 'ERROR') {
      return (
          <div className={styles.status_error}>
            Данные не получены.<br/>{this.props.result.errorMessage}
          </div>
      )
    }

    return (
        <React.Fragment>
          {this.props.link === 'wait' ?
              <div>
                <div className="file_loader"/>
              </div>
              :
              <a className={`${styles.link_with_icon} ${styles.color}`} href={this.props.link} target="_blank" rel="noopener noreferrer">
                <Icon name="icon_cheque" viewbox="0 0 24 24"/>
              </a>
          }
        </React.Fragment>
    )
  }
}

export default SelectRequestReference;
